export const USER_ACCESS = 'USER_ACCESS';
export const PORTAL_ACCESS = 'PORTAL_ACCESS';
export const UPGRADE_ACCESS = 'UPGRADE_ACCESS';
export const NO_ACCESS = 'NO_ACCESS';